import { useState, useMemo } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { fetchList } from "../../../api/server";
import { useCrm_task_statuses } from "../../../hooks";

const useFeed = (entity, entityId, branchId, feedReloadTimestamp, setItems) => {
  const userScope = useSelector((state) => state.user.scopePrefix);
  const statuses = useCrm_task_statuses();
  const [activeRecord, setActiveRecord] = useState();
  const [editVisible, setEditVisible] = useState(false);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(10);

  const { id: completedStatusId = undefined } =
    useMemo(
      () => statuses?.find((status) => status.name === "completed"),
      [statuses]
    ) || {};

  const { id: openedStatusId = undefined } =
    useMemo(
      () => statuses?.find((status) => status.name === "open"),
      [statuses]
    ) || {};
  const scope = entity && entityId ? `${entity}/${entityId}/` : "";

  const scopePrefix = useMemo(
    () => (branchId ? `branches/${branchId}/${scope}` : `${userScope}${scope}`),
    [branchId, scope, userScope]
  );

  const actvitiesPage = useMemo(
    () => ({
      current: 1,
      order: { field: "date", order: "descend" },
      pageSize: limit,
    }),
    [limit]
  );

  const initialLimit = 10;

  const loadMore = () => {
    setLimit(limit + initialLimit);
  };

  const { isLoading, data } = useQuery(
    [actvitiesPage, scope, branchId, entity, entityId, feedReloadTimestamp],
    async () => {
      const result = await fetchList("activities", {
        ...actvitiesPage,
        scopePrefix,
      });
      const non_deleted_items =
        result.data?.items?.filter((item) => !item.is_deleted) || [];
      if (setItems) {
        setItems(non_deleted_items);
      }
      setTotal(non_deleted_items.length);
      return non_deleted_items;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled: entityId !== null && entityId !== undefined,
    }
  );

  const upcoming = useMemo(
    () =>
      data?.filter(
        (i) =>
          (i.task && moment(i.task.due_date) > moment()) ||
          (i.event && moment(i.event.start_time) > moment()) ||
          (i.task && i.task.status_id !== completedStatusId)
      ) || [],
    [data, completedStatusId]
  );

  const pastactivities = useMemo(
    () =>
      data?.filter(
        (i) =>
          (i.task &&
            moment(i.task.due_date) < moment() &&
            i.task.status_id === completedStatusId) ||
          (i.event && moment(i.event.start_time) < moment())
      ) || [],
    [data, openedStatusId]
  );

  return {
    upcoming,
    pastactivities,
    activeRecord,
    setActiveRecord,
    editVisible,
    setEditVisible,
    loadMore,
    isLoading,
    total,
    limit,
  };
};

export default useFeed;
